import { SVGProps } from 'react';

export const SmallDownArrowIcon: React.FC<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg width="16" height="10" viewBox="0 0 16 10" fill="none" {...props}>
    <path d="M15 1.5L8 8.5L1 1.5" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
